import { saveSelectedBrand } from './selectedBrandActions';
import { loadDevices } from './deviceActions';
import { selectYourXIndexChanged, dropdownIndex } from './selectYourXIndexActions';
import { selectYourXDropdownToggle } from './selectYourXDropdownsActions';
import { LOAD_BRANDS_SUCCESS } from './actionTypes';

export function brandSelected(brandId, finderTypeId) {
    return function (dispatch) {
        dispatch(saveSelectedBrand(brandId));
        dispatch(loadDevices(brandId, finderTypeId));
    };
}
export function brandPrepopulated(brandId) {
    return function (dispatch) {
        dispatch(saveSelectedBrand(brandId));
        dispatch(selectYourXIndexChanged(dropdownIndex.brand));
        dispatch(selectYourXDropdownToggle(dropdownIndex.device));
    };
}
export function loadBrandsSuccess(brands) {
    return { type: LOAD_BRANDS_SUCCESS, brands };
}